module.exports = __webpack_public_path__ + "img/desc_bottom_bp4202.b9e0f9e2.png";